import amplitude from 'amplitude-js';
import Tracker from '@openreplay/tracker';
import client, { PUBLIC_CLIENT } from './client';
import * as Sentry from "@sentry/svelte";

export const formatDuration = (duration) => {
    let hours = Math.floor(duration / 3600);
    let minutes = Math.floor((duration - hours * 3600) / 60);
    let seconds = Math.floor(duration - hours * 3600 - minutes * 60);

    hours = hours < 10 ? '0' + hours : hours;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    seconds = seconds < 10 ? '0' + seconds : seconds;

    return hours + ':' + minutes + ':' + seconds;
};

export const TEST_TOKEN_RESPONSE = {
    token: "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNjg1ODk0OTEyLCJpYXQiOjE2ODU2MzU3MTIsImp0aSI6ImJjMTU2OWNjZDM3OTQ3YTJiNWRkZWEzMWYxYTcyMmY1IiwidXNlcl9pZCI6Nn0.gcf1YcCzfDSixFPeJoK-vWp9h8wAmlmHmy_XiwNMPp4"
}

export const TEST_ACCOUNT_NUMBER = "8148642968"
const AMPLITUDE_API_KEY = "d07c19eb097dad4b443472760ae7b59a"

export const openReplay = new Tracker({
	projectKey: "dqgnP5fb9BsD9nwVMFAx", //"YxLclbcf6I8FBEa4ay66",
	ingestPoint: 'https://openreplay.pressone.co/ingest',
	network: {
		capturePayload: true // Capture HTTP payload
	},
	__DISABLE_SECURE_MODE: false
});

export class AmplitudeLogger {

    logger = null;

    constructor(identifier = null){
        if (!AmplitudeLogger.logger) {
            amplitude.getInstance('admin-widget-extension').init(AMPLITUDE_API_KEY, identifier)
            AmplitudeLogger.logger = amplitude.getInstance('admin-widget-extension')
        }
        return AmplitudeLogger.logger;
    }

    static getLogger(identifier = null) {
        if( !AmplitudeLogger.logger ){
            return new AmplitudeLogger(identifier);
        }
        return AmplitudeLogger.logger;
    }

    static log(event, details = {}) {
        return AmplitudeLogger.getLogger().logEvent(`${event} [ADMIN_WIDGET]`, details);
    }

    config() {
        return {};
    }
}

export class OpenObserveLogger {

    logger = null;

    constructor(){
        if (!OpenObserveLogger.logger) {
            OpenObserveLogger.logger = this
        }
        return OpenObserveLogger.logger;
    }

    static getLogger() {
        if( !OpenObserveLogger.logger ){
            return new OpenObserveLogger();
        }
        return OpenObserveLogger.logger;
    }

    async makeRequest(event, options = {}) {
        const { auth, domain, hostname, url } = this.config()
        const { extension } = options;
        const user_extention = extension
        if ( extension ) {
            delete options.extension;
        }

        const payload = [{
            "__name__": "web_dialer_event",
            "__type__": "gauge",
            "organization": "default",
            "stream_type": "logs",
            "stream": "default",
            "domain": domain,
            "hostname": hostname,
            "event": event,
            "extension": user_extention,
            "_timestamp": (new Date()).getTime(), // In case you may be waiting certain seconds before sending in bulk, this would be the timestamp when the payload was generated
            "value": 1,
            ...options
        }]

        return await client.post({
            url,
            level: PUBLIC_CLIENT,
            payload,
            headers: {
                Authorization: `Basic ${auth}` 
            },
        });
    }

    config() {
        return {
            url: 'https://openobserve.pressone.co/api/default/ingest/metrics/_json',
            auth: "ZW5naW5lZXJpbmdAcHJlc3NvbmUuY286UU43Y1E2eW9zZm1lMHBLZA==",
            domain: "js-admin-script-staging-pressone-crm.netlify.app",
            hostname: "js-admin-script-staging-pressone-crm"
        }
    }

    /**
     * 
     * @param {"user_registration_attempt_failure | user_registration_attempt"} event 
     * @param { Object } details 
     * @returns Promise
     */
    static log(event, details = {}) {

        return new Promise((resolve, reject) => {
            OpenObserveLogger.getLogger().makeRequest(event, details).then( res => {
                console.log(res)
                resolve(res)
            }).catch( err => {
                console.log(err)
                reject(err)
            })
        });
    }
}

export const EVENTS = {
    LOGIN: "login",
    INIT_CALL: "initiate_call",
    NUMBER_SELECTED: "number_selected",
    RINGING: "ringing",
    CALL_STARTED: "call_started",
    CALL_ENDED: "call_ended",
    CALL_FAILED: "call_failed",
    LOGOUT: "logout",
    ERROR_LOG: "error_log",
    USER_REGISTRATION: "user_registration_attempt",
    USER_REGISTRATION_FAILURE: "user_registration_attempt_failure",
}

export const initSentry = () => Sentry.init({
    dsn: "https://ca72041db3ce5d351a0cc9170fecd7b8@o1125524.ingest.us.sentry.io/4507073326088192",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/pressone*\.netlify\/app/, "https://js-admin-script-staging-pressone-crm.netlify.app"], //
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    debug: false,
});